import utility from './utility';
import appOptions from './appOptions';
import CONSTANTS from './constants';
import abacus from './abacus';
import egtnlEvaluator from './egtnlWeb';
import config from './config';

function isMoveMessageHostModuleEnabled() {
    return utility.isNativeMobileRequest() === false;
}

function isVRBOCreditCardToCardEnabled() {
    return (
        utility.isNativeMobileRequest() === false &&
        appOptions.get('countryCode') === CONSTANTS.COUNTRY_CODES.US &&
        abacus.isAbacusTestEnabledAndLog('Vrbo_Web_CreditCard_To_Card_US')
    );
}

function isRequiredIndicatorEnabled() {
    return (
        utility.isNativeMobileRequest() === false &&
        abacus.isAbacusTestEnabledAndLog('Vrbo_Web_Indicate_Mandatory_Fields')
    );
}

function isRearrangeCreditCardEnabled() {
    return (
        utility.isNativeMobileRequest() === false &&
        appOptions.get('countryCode') === CONSTANTS.COUNTRY_CODES.US &&
        abacus.isAbacusTestEnabledAndLog('VRBO_CKO_Rearrange_Credit_Card_Info')
    );
}

function isEliminateCvv() {
    return (
        utility.isNativeMobileRequest() === false &&
        abacus.isAbacusTestEnabledAndLog(
            'Vrbo_Web_Eliminate_CVV_For_SignedIn_Users'
        )
    );
}
function isPaymentsSchedulesModified() {
    return (
        utility.isNativeMobileRequest() === false &&
        abacus.isAbacusTestEnabledAndLog('Vrbo_Web_Clarify_Payment_Schedules')
    );
}

function showInlineCarousel() {
    return (
        utility.isNativeMobileRequest() === false &&
        appOptions.get('countryCode') === CONSTANTS.COUNTRY_CODES.US
    );
}

function isTravelerEditAbilityDisabled() {
    return (
        appOptions.get('countryCode') === CONSTANTS.COUNTRY_CODES.US &&
        abacus.isAbacusTestEnabledAndLog(
            'Vrbo_CKO_Disable_Traveler_Edit_Ability'
        )
    );
}

/**
 * Returns true if the two-step VAS interstitial (TCP then ADP) is enabled for the current session.
 * When ipSniff (experiment 67994) is enabled, resolves the country from
 * `appOptions.get('geoCountryCode')` (post-init) with a fallback to
 * `config.geoCountryCode` (available at module load). Otherwise uses POS
 * `appOptions.get('countryCode')`.
 * @returns {boolean}
 */
function isTwoStepInterstitialTestEnabled() {
    const geoCountryCode =
        egtnlEvaluator.evaluateExperiment('67994')?.value === 1
            ? appOptions.get('geoCountryCode') ?? config.geoCountryCode ?? null
            : null;
    const resolvedCountryCode = geoCountryCode || appOptions.get('countryCode');
    const supportedCountries = [
        CONSTANTS.COUNTRY_CODES.US,
        CONSTANTS.COUNTRY_CODES.CA,
    ];

    return (
        utility.isNativeMobileRequest() === false &&
        supportedCountries.includes(resolvedCountryCode)
    );
}

function showRequiredIndicatorInfo() {
    return utility.isNativeMobileRequest() === false;
}

export default {
    isMoveMessageHostModuleEnabled,
    isRequiredIndicatorEnabled,
    isVRBOCreditCardToCardEnabled,
    isRearrangeCreditCardEnabled,
    isEliminateCvv,
    isPaymentsSchedulesModified,
    isTravelerEditAbilityDisabled,
    isTwoStepInterstitialTestEnabled,
    showRequiredIndicatorInfo,
    showInlineCarousel,
};
